import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import {
  makeStyles,
  Drawer,
  AppBar,
  Tabs,
  Tab,
  IconButton,
  Toolbar,
} from '@material-ui/core'
import ClearIcon from '@material-ui/icons/Clear'

import TabPanel from 'app/componentV4/Tabs/TabPanel'

import LoaderMessageDetail from 'app/componentV4/MessageDetail/Loader/LoaderMessageDetail'

import MessageDetail from './MessageDetail'
import useViewMessage from './useViewMessage'

const useStyles = makeStyles((theme) => ({
  drawerPaper: {
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '85%',
    },
    [theme.breakpoints.up('md')]: {
      width: '60%',
    },
    [theme.breakpoints.up('lg')]: {
      width: '40%',
    },
  },
  appBar: {
    boxShadow: 'unset',
    borderBottom: `1px solid ${theme.palette.neutrals['200']}`,
    width: '100%',
    zIndex: 99,
    [theme.breakpoints.up('sm')]: {
      width: '85%',
    },
    [theme.breakpoints.up('md')]: {
      width: '60%',
    },
    [theme.breakpoints.up('lg')]: {
      width: '40%',
    },
  },
  toolBar: {
    display: 'flex',
    justifyContent: 'space-between',
    color: '#000000',
    backgroundColor: '#FFFFFF',
    minHeight: 'unset',
    padding: '0 12px',
    height: 'fit-content !important',
    '& .MuiTab-root': {
      minWidth: 'fit-content',
      textTransform: 'capitalize',
    },
    '& .MuiTabs-scroller > span': {
      backgroundColor: '#000000',
      height: '1px',
    },
    '& .MuiTab-textColorInherit': {
      color: theme.colors['grey-600'],
      fontWeight: '600',
    },
    '& .MuiTab-textColorInherit.Mui-selected': {
      fontWeight: 'bold',
      color: '#183560',
    },
  },
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
  },
}))

const ViewMessage = (props) => {
  const { id, isOpen = false, onClose } = props

  const classes = useStyles()
  const { formatMessage } = useIntl()
  const [isOpenDetail, setIsOpenDetail] = useState(isOpen)

  const {
    state: { notificationDetail, isLoading },
    handleFetchNotificationsById,
    handleClearNotificationDetail,
  } = useViewMessage()

  const handleCloseDetail = async () => {
    await setIsOpenDetail(false)
    onClose()
    handleClearNotificationDetail()
  }

  const handleFetchMessageDetail = useCallback(async () => {
    await handleFetchNotificationsById(id)
  }, [handleFetchNotificationsById, id])

  useEffect(() => {
    handleFetchMessageDetail()
  }, [])

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      classes={{
        paper: classes.drawerPaper,
      }}
      onClose={handleCloseDetail}
      ModalProps={{
        keepMounted: true,
      }}
    >
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar className={classes.toolBar}>
          <Tabs value={0} aria-label="Message Detail Tabs">
            <Tab
              label={formatMessage({
                id: 'notificationTimeline.card.metric.openRate.notification.title',
              })}
              className="text-blue-950"
              id="Message-Detail-Information"
              aria-controls="Message-Detail-Information"
            />
          </Tabs>
          <IconButton
            edge="end"
            aria-label="Close Message Detail"
            onClick={() => handleCloseDetail()}
          >
            <ClearIcon fontSize="small" />
          </IconButton>
        </Toolbar>
      </AppBar>
      {isLoading ? (
        <LoaderMessageDetail />
      ) : (
        <div style={{ position: 'relative', top: '50px' }}>
          <TabPanel name="message-detail" value={0} index={0}>
            <MessageDetail
              value={notificationDetail}
              isOpenMessageDetail={isOpenDetail}
            />
          </TabPanel>
        </div>
      )}
    </Drawer>
  )
}

ViewMessage.propTypes = {
  id: PropTypes.number,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
}

export default ViewMessage
